import React from 'react';
import { Icon } from './Icon.js';
export const IconLineChartUp = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M2.5 20.4191L9.06666 13.8524L14.9333 19.5667L21.5 13", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M17 6L18.712 3L19 3L19.288 3L21 6L17 6Z", fill: "currentColor", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square" })));
};
//# sourceMappingURL=IconLineChartUp.js.map